import React from 'react';
import './App.css';
import SearchTool from './SearchTool';


function App() {
  return (
    <div className="App">
      <SearchTool/>
    </div>
  );
}

export default App;
